import React from 'react';
import styled from 'styled-components';

type StyledButtonProps = {
	background?: string;
	padding?: string;
};

const StyledButton = styled.button<StyledButtonProps>`
	font-size: 1rem;
	padding: ${({ padding }) => padding || '1rem 2rem'};
	cursor: pointer;
	background-color: ${({ background, theme }) =>
		background || theme.colors.main};
	color: white;
	border: 1px solid
		${({ background, theme }) => background || theme.colors.main};
	border-radius: 7px;

	&:focus {
		outline: none;
	}
`;

type buttonType = {
	children: string;
	background?: string;
	padding?: string;
};

const Button = ({ children, background, padding }: buttonType) => {
	return (
		<StyledButton background={background} padding={padding}>
			{children}
		</StyledButton>
	);
};

export default Button;
